import { FC, memo } from 'react'
import * as S from './styles'
import type { Props } from './types'

const ErrorMessage: FC<Props> = ({ children }) => {
  return <S.ErrorMessage className="error-message">{children}</S.ErrorMessage>
}

export default memo(ErrorMessage)
